module.exports = __webpack_public_path__ + "img/kctp.958211b6.png";